module.exports = {
  title: 'Twitter Tab Bar with React Navigation and Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2023-08-02',
  slug: 'twitter-tab-bar',
  tags: ['reanimated', 'react-navigation'],
};
